import React from "react";
import { motion } from "framer-motion";

const PageTransition = ({ children, location }) => {
    const variants = {
        initial: {
            opacity: 0,
            y: "100vh",
        },
        in: {
            opacity: 1,
            y: 0,
        },
        out: {
            opacity: 0,
            y: "-100vh",
        },
    };

    return (
        <motion.div
            key={location ? location.key : 'transition'}
            initial="initial"
            animate="in"
            exit="out"
            variants={variants}
            transition={{ duration: 0.8, ease: [0.43, 0.13, 0.23, 0.96] }}
            style={{ width: '100%', height: '100%' }}
        >
            {children}
        </motion.div>
    );
};

export default PageTransition;
